import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const defaultValues = {
  name: '',
  display: '',
};

const PermissionInsertModal = ({
  open,
  handleClose,
  insertLoading,
  onInsert,
}) => {
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isSubmitted },
  } = useForm({ defaultValues });

  useEffect(() => {
    if (!open) {
      reset(defaultValues);
    }
  }, [open, reset]);

  const onSubmit = data => {
    onInsert({
      name: data.name,
      display: data.display,
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>اضافه کردن دسترسی جدید</DialogTitle>

      <DialogContent>
        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              autoFocus
              dir="ltr"
              label="عنوان سیستمی"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('name', { required: 'عنوان سیستمی الزامی است' })}
              error={isSubmitted ? !!errors.name : null}
              helperText={errors.name?.message}
            />
          </FormControl>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              label="عنوان نمایشی"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('display', { required: 'عنوان نمایشی الزامی است' })}
              error={isSubmitted ? !!errors.name : null}
              helperText={errors.name?.message}
            />
          </FormControl>
        </FormFieldWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={insertLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          color="warning"
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          loading={insertLoading}
        >
          اضافه کردن
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default PermissionInsertModal;

const FormFieldWrapper = styled.div`
  margin: 20px 8px 0;
  min-width: 300px;
`;
